import React, { useState } from "react";
import { Component } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import { Link, withRouter, useHistory } from "react-router-dom";
import {
  USER_PROFILE_SIDEBAR,
  USER_DATA,
  USER_STUDENT,
} from "../../helpers/constants";
import UserProfileSidebar from "./UserProfileSidebar";
import Breadcrumbs from "../common/Breadcrumbs";
import CommonIcon from "../common/CommonIcon";

const UserInformation = ({ children, history, location }) => {
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem(USER_DATA))
  );
  const { pathname } = location;
  const onLogout = () => {
    try {
      localStorage.removeItem(USER_DATA);
      this.props.history.push("/");
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <React.Fragment>
      <div className="account-main">
        <Container style={{ maxWidth: "992px" }}>
          <Row className="w-100 align-items-center justify-content-end m-0">
            <Col className="p-0 mt-5">
              {/* <nav id="navbar" className="navbar user-profile-header">
                {localStorage.getItem(USER_DATA) &&
                  [
                    "/help",
                    "/messages",
                    "/notifications",
                    "/account",
                    "/user-general-information",
                    "/user-biographic-information",
                    "/user-academic-information",
                    "/user-professional-information",
                  ].includes(pathname) && (
                    <ul className="ml-auto mt-4">
                      <li>
                        <Link
                          to="/help"
                          className={`nav-link${
                            pathname.includes("/help") ? " active" : ""
                          } nav-account`}
                        >
                          <i className="bx bx-help-circle bx-sm lh-1"></i>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/messages"
                          className={`nav-link${
                            pathname.includes("/messages") ? " active" : ""
                          } nav-account`}
                        >
                          <i className="bx bxs-message-dots bx-sm lh-1"></i>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/notifications"
                          className={`nav-link${
                            pathname.includes("/notifications") ? " active" : ""
                          } nav-account`}
                        >
                          <i className="bx bxs-bell bx-sm lh-1"></i>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className={`nav-link nav-account`}
                          onClick={() => onLogout()}
                        >
                          <i className="bx bx-log-out-circle bx-sm lh-1"></i>
                        </Link>
                      </li>
                    </ul>
                  )}
              </nav> */}
             <div className="flex justify-between mb-3 mt-2">
                <Breadcrumbs
                  subtitle="opportunites"
                  subtitleLink="/opportunites"
                  extratitle="Home"
                  extratitleLink="/"
                  currentTile="Home"
                />
               <CommonIcon/>
             
            
                </div>
            </Col>
          </Row>
            
        </Container>
        <Container className="pb-4 px-2" style={{ maxWidth: "992px" }}>
          <Row className="row justify-content-between mt-4 mb-5">
            <Col className="custom-sidebar user-custom-sidebar">
              <UserProfileSidebar
                user={userData}
                pathname={location.pathname}
              />
            </Col>
            <Col className="custom-sidebar-content">{children}</Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
UserInformation.propTypes = {
  children: PropTypes.node,
};
export default withRouter(UserInformation);
